import Vue from 'vue';

const firstUppercase = Vue.filter('firstUppercase', value => {
  if (!value || typeof value !== 'string') return '';

  const firstLetter = value.charAt(0);
  const fisteUppercaseLetter = firstLetter.toUpperCase();
  const allWithoutFirstLetter = value.slice(1);

  return `${fisteUppercaseLetter}${allWithoutFirstLetter.toLowerCase()}`;
});

const lowercase = Vue.filter('lowercase', value => {
  if (!value || typeof value !== 'string') return '';

  return value.toLowerCase();
});

const formatPrice = Vue.filter('formatPrice', price => {
  if (price === null || price === undefined) return '';

  // Convert to number if it's a string
  const numPrice = typeof price === 'string' ? parseFloat(price) : price;

  // Check if it's a valid number
  if (isNaN(numPrice)) return '';

  // Format with locale-specific formatting (thousands separators, etc.)
  return Number(numPrice).toLocaleString(undefined, {
    minimumFractionDigits: Number.isInteger(numPrice) ? 0 : 2,
    maximumFractionDigits: 2
  });
});

export default {
  firstUppercase,
  lowercase,
  formatPrice
};
